import React from "react";

import { Card, Button, DatePicker, message, Progress } from "antd";
import moment from "moment";

import api from "../../../services/api";
import axios from "axios";

import ExportJsonExcel from "js-export-excel";

const { RangePicker } = DatePicker;

export default class RD extends React.Component {
  state = {
    increase: 0,
    showProgress: false
  };

  users = null;
  token = null;

  qualificacao = "b45c5d60758d06a5212da633b04de8bd1982b2dc";
  pasta = "f9a0b58d523b64c5a881371570b3fdefeccdc0b8";
  data_acidente = "507c4781804413b1621532589ecd42a31fa20a84";

  arrUnique(arr) {
    var cleaned = [];
    arr.map(value => {
      var unique = true;
      cleaned.map(value2 => {
        if (value.email == value2.email) unique = false;
      });
      if (unique == true) {
        cleaned.push(value);
      }
    });
    return cleaned;
  }

  calcula_progresso(total) {
    const increase = 100 / total;
    this.setState({
      ...this.state,
      showProgress: true,
      increase: increase,
      porcentagem: 0
    });
  }

  componentDidMount = async () => {
    const users = await api("/usuario/");
    //console.log(users)
    this.users = users.data;
    console.log(this.users);
    const res_token_pipedrive = await api.get("/tokens/");
    this.token = res_token_pipedrive.data.pipedrive;
  };

  handleOnClick = async () => {
    this.setState({
      ...this.state,
      showProgress: true,
      increase: 0,
      porcentagem: 0
    });
    if (this.state == null) {
      message.error("Selecione um período!");
      return;
    }
    let deals = await this.getData();
    this.calcula_progresso(deals.length);
    this.createJSONXLSX(deals);
  };

  getStageName = id => {
    if (id == 14) return "Aguardar passivo";
    else return "Iniciar contato";
  };

  createJSONXLSX = async deals => {
    let data = [];
    let i = 0;
    for (i; i < deals.length; i++) {
      const deal = deals[i];
      console.log(deal);
      const add_time = deal["add_time"].split(" ")[0];
      if (add_time <= this.state.fin && add_time >= this.state.ini) {
        let participantes = await this.getParticipantes(deals[i]);
        participantes.data.data.map(value => {
          //console.log(value['person_id']['value'], value['person'][this.qualificacao])
          const qualificacao = value["person"][this.qualificacao];
          if (qualificacao != 58 && qualificacao != 28) {
            value.person_id.email.map(email => {
              if (email.value != "" && email.value != null) {
                let line = {
                  pessoa_id: value.person_id.value,
                  pasta: deal[this.pasta],
                  pessoa_nome: value.person_id.name,
                  email: email.value,
                  data_acidente: deal[this.data_acidente],
                  data_higienizacao: add_time,
                  funil: "SDR",
                  etapa: this.getStageName(deal.id),
                  operador: deal.user_id.name,
                  operador_email: deal.user_id.email
                };
                this.users.map(user => {
                  //console.log(user.id_pipedrive, value..value)
                  if (user.id_pipedrive == deal.user_id.value) {
                    line["whatsapp"] = user.link_wpp.split("/55")[1];
                  }
                });
                if (qualificacao == 18) line["qualificacao"] = "Condutor";
                else if (qualificacao == 20)
                  line["qualificacao"] = "Condutor e Proprietário";
                else if (qualificacao == 17)
                  line["qualificacao"] = "Condutor Segurado";
                else if (qualificacao == 19)
                  line["qualificacao"] = "Proprietário";
                else if (qualificacao == 29) line["qualificacao"] = "Segurado";
                else line["qualificacao"] = "VERIFICAR";
                data.push(line);
              }
            });
          }
        });
      }
      this.setState({
        ...this.state,
        porcentagem: this.state.porcentagem + this.state.increase
      });

      //
      //break
    }
    this.setState({
      ...this.state,
      showProgress: false
    });
    console.log(data);
    this.downloadExcel(data);
  };

  downloadExcel = data => {
    var option = {};
    data = this.arrUnique(data);
    let dataTable = data;
    option.fileName = "Relatório RD";
    option.datas = [
      {
        sheetData: dataTable,
        sheetName: "sheet",
        sheetHeader: [
          "pessoa_id",
          "pasta",
          "pessoa_nome",
          "email",
          "data_acidente",
          "data_higienizacao",
          "funil",
          "etapa",
          "operador",
          "operador_email",
          "whatsapp",
          "qualificacao"
        ]
      }
    ];

    var toExcel = new ExportJsonExcel(option);
    console.log("aqui");
    toExcel.saveExcel();
  };

  getParticipantes = async deal => {
    let res = await axios.get(
      `https://api.pipedrive.com/v1/deals/${deal.id}/participants?start=0&api_token=${this.token}`
    );
    //console.log(res)
    return res;
  };

  handleOnChange = e => {
    this.setState({
      ...this.state,
      ini: moment(e[0]).format("YYYY-MM-DD"),
      fin: moment(e[1]).format("YYYY-MM-DD")
    });
  };

  getData = async () => {
    let deals = [];
    let start = 0;
    let r = {
      data: {
        data: {}
      }
    };
    while (r.data.data != null) {
      r = await axios.get(
        `https://api.pipedrive.com/v1/deals?filter_id=577&status=all_not_deleted&start=${start}&limit=500&api_token=${this.token}`
      );
      if (r.data.data != null) deals = [...deals, ...r.data.data];
      start = start + 500;
    }
    return deals;
  };

  render() {
    if (this.state.showProgress) {
      return (
        <React.Fragment>
          <br />
          <div style={{ textAlign: "center", marginTop: "20%" }}>
            <Progress
              type="dashboard"
              width={250}
              percent={this.state.porcentagem.toFixed(2)}
            />
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <br></br>
        <Card title="Relatorio de Emails RD">
          Período de Importação: <RangePicker onChange={this.handleOnChange} />
          <br />
          <br />
          <Button type="primary" onClick={this.handleOnClick}>
            Gerar
          </Button>
        </Card>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Relatorios/RelatorioRD/index.js